export { default as AcademicDateIcon } from "./date";
export { default as AcademicActivityIcon } from "./activity";
export { default as AcademicDurationIcon } from "./duration";
export { default as AcademicVideoIcon } from "./video";
export { default as AcademicGameIcon } from "./game";
export { default as AcademicBookIcon } from "./book";
